import { clearCookie } from '@utils/web-storage';
import { oauthSecureRequest } from '@utils/request';

export const revokeToken = async (): Promise<void> => {
	clearCookie('userLoggedIn');
	await oauthSecureRequest.get('/revoke-access', { withCredentials: true });
};
